import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import Logo from "../assets/logo-2.png";
import Button from "./Button";

export default function Header() {
  const { pathname } = useLocation();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [navbarFixed, setNavbarFixed] = useState(false);

  const [scrollingDown, setScrollingDown] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      setScrolled(currentScrollY > 50); // Adds white bg to navbar when scrolled
      setScrollingDown(currentScrollY > 0); // Hides top header if scrolled even 1px
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const closeOffcanvas = () => {
    const offcanvas = document.querySelector(".offcanvas.show");
    if (offcanvas) {
      const offcanvasInstance =
        window.bootstrap.Offcanvas.getInstance(offcanvas);
      offcanvasInstance?.hide();
    }
  };

  return (
    <>
      <div
        className={`container-fluid d-md-flex flex-column p-0 transparent-navbar 
    ${scrollingDown ? "hide-top-header" : ""} 
    ${scrolled ? "navbar-visible" : ""}`}
      >
        <div className="container header d-none d-md-flex justify-content-between align-items-center py-3">
          <div className="d-flex align-items-center text-white">
            <span className="px-3">
              <a
                href="tel:0424955982"
                className="text-white text-decoration-none"
              >
                <i className="bi bi-telephone-fill me-1"></i> 0424 955 982
              </a>
            </span>

            <span className="px-3">
              <a
                href="https://maps.app.goo.gl/dtzU7ZViSnRfMwoRA"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white text-decoration-none"
              >
                <i className="bi bi-geo-alt-fill me-1"></i> Suite 5/429 High
                Street, Penrith, NSW 2750
              </a>
            </span>
          </div>

          <div className="d-flex gap-4">
            <a
              href="https://www.facebook.com/profile.php?id=61559035348971"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white"
              aria-label="Urban View Real Estate Facebook"
            >
              <i className="bi bi-facebook" aria-hidden="true"></i>
            </a>

            <a
              href="https://www.instagram.com/urbanviewrealestate"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white"
              aria-label="Urban View Real Estate Instagram"
            >
              <i className="bi bi-instagram" aria-hidden="true"></i>
            </a>

            <a
              href="/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white"
              aria-label="Urban View Real Estate LinkedIn"
            >
              <i className="bi bi-linkedin" aria-hidden="true"></i>
            </a>
          </div>
        </div>

        <nav
          className={`navbar navbar-expand-lg border-secondary py-0   ${
            scrolled ? "shadow-sm navbar-visible" : "navbar-set"
          } `}
        >
          <div className="container">
            <Link
              className="navbar-brand d-flex align-items-center py-3"
              to="/"
            >
              <img src={Logo} alt="Logo" height="60" />
            </Link>

            <button
              className="navbar-toggler border rounded-0"
              type="button"
              data-bs-toggle="offcanvas"
              data-bs-target="#offcanvasNavbar"
              aria-controls="offcanvasNavbar"
              aria-label="Open navigation menu"
            >
              <span className="navbar-toggler-icon"></span>
            </button>

            <div
              className="collapse navbar-collapse justify-content-end"
              id="navbarNav"
            >
              <ul className="navbar-nav px-2">
                <li className="nav-item px-2 py-3">
                  <Link
                    className={`nav-link fs-5 fw-bold ${
                      pathname === "/" ? "active" : ""
                    } ${scrolled || !scrollingDown ? "text-dark" : "text-white"}`}
                    to="/"
                  >
                    Home
                  </Link>
                </li>

                <li
                  className="nav-item dropdown px-2 py-3 position-relative"
                  onMouseEnter={() => setIsDropdownOpen(true)}
                  onMouseLeave={() => setIsDropdownOpen(false)}
                >
                  <button
                    type="button"
                    className={`nav-link fs-5 fw-bold border-0 bg-transparent ${
                      scrolled || !scrollingDown ? "text-dark" : "text-white"
                    }`}
                  >
                    About{" "}
                    <i
                      className={`bi bi-plus position-relative ${
                        scrolled || !scrollingDown ? "text-dark" : "text-white"
                      }`}
                      style={{ left: "-7px" }}
                    ></i>
                  </button>

                  <ul
                    className={`dropdown-menu rounded-0 ${
                      isDropdownOpen ? "show" : ""
                    }`}
                  >
                    <li>
                      <Link
                        className={`dropdown-item ${
                          pathname === "/about" ? "active" : "text-muted"
                        }`}
                        to="/about"
                      >
                        About
                      </Link>
                    </li>
                    <li>
                      <Link
                        className={`dropdown-item ${
                          pathname === "/services" ? "active" : "text-muted"
                        }`}
                        to="/services"
                      >
                        Services
                      </Link>
                    </li>
                    <li>
                      <Link
                        className={`dropdown-item ${
                          pathname === "/team" ? "active" : "text-muted"
                        }`}
                        to="/team"
                      >
                        Team
                      </Link>
                    </li>
                  </ul>
                </li>

                <li className="nav-item px-2 py-3">
                  <Link
                    className={`nav-link fs-5 fw-bold ${
                      pathname === "/properties" ? "active" : ""
                    } ${scrolled || !scrollingDown ? "text-dark" : "text-white"}`}
                    to="/properties"
                  >
                    Properties
                  </Link>
                </li>

                <li className="nav-item px-2 py-3">
                  <Link
                    className={`nav-link fs-5 fw-bold ${
                      pathname === "/blogs" ? "active" : ""
                    } ${scrolled || !scrollingDown ? "text-dark" : "text-white"}`}
                    to="/"
                  >
                    Blogs
                  </Link>
                </li>

                <li className="nav-item px-2 py-3">
                  <Link
                    className={`nav-link fs-5 fw-bold ${
                      pathname === "/contact" ? "active" : ""
                    } ${scrolled || !scrollingDown ? "text-dark" : "text-white"}`}
                    to="/contact"
                  >
                    Contact
                  </Link>
                </li>
              </ul>
              <div className="d-none d-md-flex align-items-center gap-3 py-2">
                <Link to="/appraisal">
                  <button className={`button brand text-dark`}>
                    Request Appraisal
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </nav>

        {/* Offcanvas Menu */}
        <div
          className="offcanvas offcanvas-end bg-white w-100"
          tabIndex="-1"
          id="offcanvasNavbar"
          aria-labelledby="offcanvasNavbarLabel"
        >
          <div className="offcanvas-header border-light border-bottom text-white">
            <img src={Logo} alt="Logo" height={60} />
            <button
              type="button"
              className="btn-close bg-white"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
            ></button>
          </div>
          <div className="offcanvas-body text-dark d-flex flex-column align-items-center justify-content-center vh-100 gap-5">
            <ul className="navbar-nav text-center gap-4">
              <li className="nav-item mb-3">
                <Link
                  className={`nav-link fw-bold fs-5 ${
                    pathname === "/" ? "active" : ""
                  }`}
                  to="/"
                  onClick={closeOffcanvas}
                >
                  Home
                </Link>
              </li>
              <li className="nav-item text-center mb-3">
                <button
                  className="nav-link text-center fw-bold fs-5"
                  onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                >
                  About{" "}
                  <i
                    className={`bi bi-plus text-dark position-relative ${
                      isDropdownOpen ? "rotate-45" : ""
                    }`}
                    style={{ left: "-7px" }}
                  ></i>
                </button>
                <ul
                  className={`dropdown-menu text-dark rounded-0 ${
                    isDropdownOpen ? "show" : ""
                  }`}
                >
                  <li>
                    <Link
                      className={`dropdown-item text-muted ${
                        pathname === "/about" ? "active" : ""
                      }`}
                      to="/about"
                      onClick={closeOffcanvas}
                    >
                      About
                    </Link>
                  </li>
                  <li>
                    <Link
                      className={`dropdown-item text-muted ${
                        pathname === "/services" ? "active" : ""
                      }`}
                      to="/services"
                      onClick={closeOffcanvas}
                    >
                      Services
                    </Link>
                  </li>
                  <li>
                    <Link
                      className={`dropdown-item text-muted ${
                        pathname === "/team" ? "active" : ""
                      }`}
                      to="/team"
                      onClick={closeOffcanvas}
                    >
                      Team
                    </Link>
                  </li>
                </ul>
              </li>
              <li className="nav-item mb-3">
                <Link
                  className="nav-link fw-bold fs-5"
                  to="/properties"
                  onClick={closeOffcanvas}
                >
                  Properties
                </Link>
              </li>

              <li className="nav-item mb-3">
                <Link
                  className="nav-link fw-bold fs-5"
                  to="/"
                  onClick={closeOffcanvas}
                >
                  Blogs
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className={`nav-link fw-bold fs-5 ${
                    pathname === "/contact" ? "active" : ""
                  }`}
                  to="/contact"
                  onClick={closeOffcanvas}
                >
                  Contact
                </Link>
              </li>
            </ul>
            <div className="d-flex align-items-center gap-3 py-2">
              <Link to="/appraisal" onClick={closeOffcanvas}>
                <Button text="Request Appraisal" className="text-dark" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
